import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';

@Component({
  selector: 'app-early-access-subscribe-modal',
  templateUrl: './subscribe-modal.component.html',
  styleUrls: ['./subscribe-modal.component.scss']
})
export class EarlyAccessSubscribeModalComponent implements OnInit, AfterViewInit {
  @Input() modal_text: string = '';
  window: any = window;

  constructor(
    // public modal: NgbActiveModal,
    // protected modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.window['hbspt'].forms.create({
      target: '#subscribe-modal',
      region: 'na1',
      portalId: '2533471',
      formId: 'e147a325-a694-480c-bd60-4018e9840cd1',
      onFormReady: ($form: any) => {
        $form.find('[name="data_visualization_early_access_feature"]').val(this.modal_text);
      },
      onFormSubmit: ($form: any) => { },
    });
  }

}
